export const PFCharacterData = [
  {
    char: 'acheron',
    name: 'Acheron',
    current_app_rate: 15.2,
    prev_app_rate: 30.41,
    current_avg_score: 27481,
    prev_avg_score: 29115,
    app_eidolons: 10.69,
    app_free: 0.48,
    round_eidolons: 33233,
    round_free: 26039,
    rarity: 'Limited 5*'
  },
  {
    char: 'aglaea',
    name: 'Aglaea',
    current_app_rate: 2.12,
    prev_app_rate: 12.8,
    current_avg_score: 25950,
    prev_avg_score: 31809,
    app_eidolons: 1.75,
    app_free: 0.01,
    round_eidolons: 32720,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'anaxa',
    name: 'Anaxa',
    current_app_rate: 7.24,
    prev_app_rate: 7.24,
    current_avg_score: 38177,
    prev_avg_score: 38177,
    app_eidolons: 3.81,
    app_free: 1.05,
    round_eidolons: 39818,
    round_free: 35619,
    rarity: 'Limited 5*'
  },
  {
    char: 'argenti',
    name: 'Argenti',
    current_app_rate: 6.53,
    prev_app_rate: 4.89,
    current_avg_score: 33144,
    prev_avg_score: 34296,
    app_eidolons: 3.22,
    app_free: 1.25,
    round_eidolons: 34981,
    round_free: 31557,
    rarity: 'Limited 5*'
  },
  {
    char: 'arlan',
    name: 'Arlan',
    current_app_rate: 0.01,
    prev_app_rate: 0.01,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'asta',
    name: 'Asta',
    current_app_rate: 0.11,
    prev_app_rate: 0.1,
    current_avg_score: 0,
    prev_avg_score: 27131,
    app_eidolons: 0.06,
    app_free: 0.03,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'aventurine',
    name: 'Aventurine',
    current_app_rate: 30.07,
    prev_app_rate: 43.97,
    current_avg_score: 34765,
    prev_avg_score: 33933,
    app_eidolons: 15.33,
    app_free: 4.73,
    round_eidolons: 35101,
    round_free: 37785,
    rarity: 'Limited 5*'
  },
  {
    char: 'bailu',
    name: 'Bailu',
    current_app_rate: 0.7,
    prev_app_rate: 0.62,
    current_avg_score: 32869,
    prev_avg_score: 32045,
    app_eidolons: 0.39,
    app_free: 0.04,
    round_eidolons: 37675,
    round_free: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'black-swan',
    name: 'Black Swan',
    current_app_rate: 2.08,
    prev_app_rate: 4.56,
    current_avg_score: 25540,
    prev_avg_score: 24560,
    app_eidolons: 1.28,
    app_free: 0.14,
    round_eidolons: 27109,
    round_free: 24527,
    rarity: 'Limited 5*'
  },
  {
    char: 'blade',
    name: 'Blade',
    current_app_rate: 1.28,
    prev_app_rate: 1.04,
    current_avg_score: 29159,
    prev_avg_score: 30902,
    app_eidolons: 0.71,
    app_free: 0.13,
    round_eidolons: 32215,
    round_free: 26920,
    rarity: 'Limited 5*'
  },
  {
    char: 'boothill',
    name: 'Boothill',
    current_app_rate: 0.07,
    prev_app_rate: 0.08,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.06,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'bronya',
    name: 'Bronya',
    current_app_rate: 4.38,
    prev_app_rate: 3.28,
    current_avg_score: 30504,
    prev_avg_score: 29635,
    app_eidolons: 2.54,
    app_free: 0.43,
    round_eidolons: 34307,
    round_free: 27645,
    rarity: 'Standard 5*'
  },
  {
    char: 'castorice',
    name: 'Castorice',
    current_app_rate: 55.16,
    prev_app_rate: 12.67,
    current_avg_score: 34292,
    prev_avg_score: 36924,
    app_eidolons: 28.62,
    app_free: 3.35,
    round_eidolons: 39231,
    round_free: 31475,
    rarity: 'Limited 5*'
  },
  {
    char: 'clara',
    name: 'Clara',
    current_app_rate: 1.77,
    prev_app_rate: 0.95,
    current_avg_score: 24409,
    prev_avg_score: 27058,
    app_eidolons: 0.93,
    app_free: 0.28,
    round_eidolons: 27084,
    round_free: 24137,
    rarity: 'Standard 5*'
  },
  {
    char: 'dan-heng',
    name: 'Dan Heng',
    current_app_rate: 0,
    prev_app_rate: 0.01,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'dr-ratio',
    name: 'Dr. Ratio',
    current_app_rate: 0.01,
    prev_app_rate: 0.04,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'feixiao',
    name: 'Feixiao',
    current_app_rate: 1.29,
    prev_app_rate: 2.73,
    current_avg_score: 25851,
    prev_avg_score: 28801,
    app_eidolons: 1.02,
    app_free: 0.06,
    round_eidolons: 31518,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'firefly',
    name: 'Firefly',
    current_app_rate: 10.21,
    prev_app_rate: 14.54,
    current_avg_score: 24649,
    prev_avg_score: 25721,
    app_eidolons: 9.39,
    app_free: 0.25,
    round_eidolons: 33393,
    round_free: 23712,
    rarity: 'Limited 5*'
  },
  {
    char: 'fu-xuan',
    name: 'Fu Xuan',
    current_app_rate: 13.27,
    prev_app_rate: 19.55,
    current_avg_score: 37701,
    prev_avg_score: 32571,
    app_eidolons: 8.21,
    app_free: 1.61,
    round_eidolons: 37751,
    round_free: 38192,
    rarity: 'Limited 5*'
  },
  {
    char: 'gallagher',
    name: 'Gallagher',
    current_app_rate: 40.83,
    prev_app_rate: 26.38,
    current_avg_score: 33865,
    prev_avg_score: 32992,
    app_eidolons: 20.7,
    app_free: 4.38,
    round_eidolons: 35294,
    round_free: 32689,
    rarity: '4*'
  },
  {
    char: 'gepard',
    name: 'Gepard',
    current_app_rate: 0.41,
    prev_app_rate: 0.65,
    current_avg_score: 27004,
    prev_avg_score: 25562,
    app_eidolons: 0.26,
    app_free: 0.03,
    round_eidolons: 32797,
    round_free: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'guinaifen',
    name: 'Guinaifen',
    current_app_rate: 0.03,
    prev_app_rate: 0.12,
    current_avg_score: 0,
    prev_avg_score: 23890,
    app_eidolons: 0.01,
    app_free: 0.01,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'hanya',
    name: 'Hanya',
    current_app_rate: 0.04,
    prev_app_rate: 0.05,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0.01,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'herta',
    name: 'Herta',
    current_app_rate: 40.28,
    prev_app_rate: 59.64,
    current_avg_score: 39579,
    prev_avg_score: 37655,
    app_eidolons: 17.71,
    app_free: 8.83,
    round_eidolons: 39984,
    round_free: 39123,
    rarity: '4*'
  },
  {
    char: 'himeko',
    name: 'Himeko',
    current_app_rate: 2.71,
    prev_app_rate: 8.18,
    current_avg_score: 26204,
    prev_avg_score: 29640,
    app_eidolons: 1.92,
    app_free: 0.32,
    round_eidolons: 31735,
    round_free: 25071,
    rarity: 'Standard 5*'
  },
  {
    char: 'hook',
    name: 'Hook',
    current_app_rate: 0,
    prev_app_rate: 0.01,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'huohuo',
    name: 'Huohuo',
    current_app_rate: 21.78,
    prev_app_rate: 25.19,
    current_avg_score: 37125,
    prev_avg_score: 33925,
    app_eidolons: 10.96,
    app_free: 3.71,
    round_eidolons: 37894,
    round_free: 37178,
    rarity: 'Limited 5*'
  },
  {
    char: 'imbibitor-lunae',
    name: 'Imbibitor Lunae',
    current_app_rate: 0.24,
    prev_app_rate: 0.97,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.23,
    app_free: 0,
    round_eidolons: 26372,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'jade',
    name: 'Jade',
    current_app_rate: 21.61,
    prev_app_rate: 27.67,
    current_avg_score: 39727,
    prev_avg_score: 39186,
    app_eidolons: 9.94,
    app_free: 4.63,
    round_eidolons: 40000,
    round_free: 39274,
    rarity: 'Limited 5*'
  },
  {
    char: 'jiaoqiu',
    name: 'Jiaoqiu',
    current_app_rate: 13.44,
    prev_app_rate: 18.87,
    current_avg_score: 28181,
    prev_avg_score: 30172,
    app_eidolons: 9.37,
    app_free: 0.38,
    round_eidolons: 34622,
    round_free: 27023,
    rarity: 'Limited 5*'
  },
  {
    char: 'jing-yuan',
    name: 'Jing Yuan',
    current_app_rate: 3.2,
    prev_app_rate: 11.37,
    current_avg_score: 28745,
    prev_avg_score: 29538,
    app_eidolons: 2.12,
    app_free: 0.19,
    round_eidolons: 33688,
    round_free: 25688,
    rarity: 'Limited 5*'
  },
  {
    char: 'jingliu',
    name: 'Jingliu',
    current_app_rate: 0.12,
    prev_app_rate: 0.29,
    current_avg_score: 0,
    prev_avg_score: 24573,
    app_eidolons: 0.06,
    app_free: 0.01,
    round_eidolons: 0,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'kafka',
    name: 'Kafka',
    current_app_rate: 1.96,
    prev_app_rate: 6.01,
    current_avg_score: 25365,
    prev_avg_score: 25176,
    app_eidolons: 1.35,
    app_free: 0.09,
    round_eidolons: 27642,
    round_free: 24227,
    rarity: 'Limited 5*'
  },
  {
    char: 'lingsha',
    name: 'Lingsha',
    current_app_rate: 33.45,
    prev_app_rate: 37.9,
    current_avg_score: 38120,
    prev_avg_score: 34841,
    app_eidolons: 20.01,
    app_free: 4.63,
    round_eidolons: 37747,
    round_free: 35040,
    rarity: 'Limited 5*'
  },
  {
    char: 'luka',
    name: 'Luka',
    current_app_rate: 0.01,
    prev_app_rate: 0.01,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'luocha',
    name: 'Luocha',
    current_app_rate: 28.35,
    prev_app_rate: 12.53,
    current_avg_score: 33586,
    prev_avg_score: 33357,
    app_eidolons: 15.64,
    app_free: 2.08,
    round_eidolons: 38567,
    round_free: 31800,
    rarity: 'Limited 5*'
  },
  {
    char: 'lynx',
    name: 'Lynx',
    current_app_rate: 0.56,
    prev_app_rate: 0.44,
    current_avg_score: 29711,
    prev_avg_score: 29251,
    app_eidolons: 0.26,
    app_free: 0.07,
    round_eidolons: 34293,
    round_free: 28748,
    rarity: '4*'
  },
  {
    char: 'march-7th',
    name: 'March 7th',
    current_app_rate: 0.11,
    prev_app_rate: 0.18,
    current_avg_score: 0,
    prev_avg_score: 31634,
    app_eidolons: 0.05,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'march-7th-swordmaster',
    name: 'March 7th - The Hunt',
    current_app_rate: 0.29,
    prev_app_rate: 0.53,
    current_avg_score: 23522,
    prev_avg_score: 24332,
    app_eidolons: 0.14,
    app_free: 0.06,
    round_eidolons: 25696,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'misha',
    name: 'Misha',
    current_app_rate: 0.01,
    prev_app_rate: 0.01,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'moze',
    name: 'Moze',
    current_app_rate: 0,
    prev_app_rate: 0.1,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'mydei',
    name: 'Mydei',
    current_app_rate: 11.23,
    prev_app_rate: 4.01,
    current_avg_score: 30065,
    prev_avg_score: 28823,
    app_eidolons: 6.1,
    app_free: 0.98,
    round_eidolons: 35340,
    round_free: 26932,
    rarity: 'Limited 5*'
  },
  {
    char: 'natasha',
    name: 'Natasha',
    current_app_rate: 0.04,
    prev_app_rate: 0.03,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.02,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'pela',
    name: 'Pela',
    current_app_rate: 5.88,
    prev_app_rate: 12.71,
    current_avg_score: 28066,
    prev_avg_score: 28871,
    app_eidolons: 2.97,
    app_free: 0.32,
    round_eidolons: 31397,
    round_free: 26498,
    rarity: '4*'
  },
  {
    char: 'qingque',
    name: 'Qingque',
    current_app_rate: 0.14,
    prev_app_rate: 0.34,
    current_avg_score: 0,
    prev_avg_score: 24422,
    app_eidolons: 0.09,
    app_free: 0.02,
    round_eidolons: 26800,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'rappa',
    name: 'Rappa',
    current_app_rate: 12.56,
    prev_app_rate: 15.09,
    current_avg_score: 29184,
    prev_avg_score: 31385,
    app_eidolons: 8.47,
    app_free: 1.78,
    round_eidolons: 33632,
    round_free: 27390,
    rarity: 'Limited 5*'
  },
  {
    char: 'robin',
    name: 'Robin',
    current_app_rate: 35.04,
    prev_app_rate: 44.87,
    current_avg_score: 34203,
    prev_avg_score: 32657,
    app_eidolons: 19.27,
    app_free: 5.52,
    round_eidolons: 37834,
    round_free: 34086,
    rarity: 'Limited 5*'
  },
  {
    char: 'ruan-mei',
    name: 'Ruan Mei',
    current_app_rate: 47.97,
    prev_app_rate: 46.83,
    current_avg_score: 29866,
    prev_avg_score: 31048,
    app_eidolons: 35.55,
    app_free: 3.81,
    round_eidolons: 34043,
    round_free: 27317,
    rarity: 'Limited 5*'
  },
  {
    char: 'sampo',
    name: 'Sampo',
    current_app_rate: 0.01,
    prev_app_rate: 0.03,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'seele',
    name: 'Seele',
    current_app_rate: 0.11,
    prev_app_rate: 0.26,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.1,
    app_free: 0.01,
    round_eidolons: 25030,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'serval',
    name: 'Serval',
    current_app_rate: 3.54,
    prev_app_rate: 6.77,
    current_avg_score: 37842,
    prev_avg_score: 37461,
    app_eidolons: 1.64,
    app_free: 0.71,
    round_eidolons: 40000,
    round_free: 36393,
    rarity: '4*'
  },
  {
    char: 'silver-wolf',
    name: 'Silver Wolf',
    current_app_rate: 0.51,
    prev_app_rate: 1.06,
    current_avg_score: 24783,
    prev_avg_score: 24020,
    app_eidolons: 0.33,
    app_free: 0.01,
    round_eidolons: 26695,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'sparkle',
    name: 'Sparkle',
    current_app_rate: 7.31,
    prev_app_rate: 12.15,
    current_avg_score: 28911,
    prev_avg_score: 28957,
    app_eidolons: 5.65,
    app_free: 0.34,
    round_eidolons: 33014,
    round_free: 28021,
    rarity: 'Limited 5*'
  },
  {
    char: 'sunday',
    name: 'Sunday',
    current_app_rate: 36.12,
    prev_app_rate: 39.71,
    current_avg_score: 33524,
    prev_avg_score: 31579,
    app_eidolons: 19.98,
    app_free: 3.02,
    round_eidolons: 37281,
    round_free: 32765,
    rarity: 'Limited 5*'
  },
  {
    char: 'sushang',
    name: 'Sushang',
    current_app_rate: 0,
    prev_app_rate: 0,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'the-herta',
    name: 'The Herta',
    current_app_rate: 58.54,
    prev_app_rate: 69.59,
    current_avg_score: 39928,
    prev_avg_score: 39065,
    app_eidolons: 24.66,
    app_free: 12.92,
    round_eidolons: 40000,
    round_free: 39705,
    rarity: 'Limited 5*'
  },
  {
    char: 'tingyun',
    name: 'Tingyun',
    current_app_rate: 1.71,
    prev_app_rate: 2.14,
    current_avg_score: 26925,
    prev_avg_score: 28651,
    app_eidolons: 0.78,
    app_free: 0.38,
    round_eidolons: 31840,
    round_free: 26520,
    rarity: '4*'
  },
  {
    char: 'tingyun-fugue',
    name: 'Fugue',
    current_app_rate: 22.38,
    prev_app_rate: 29.59,
    current_avg_score: 28779,
    prev_avg_score: 30980,
    app_eidolons: 17.52,
    app_free: 2.02,
    round_eidolons: 33788,
    round_free: 27174,
    rarity: 'Limited 5*'
  },
  {
    char: 'topaz',
    name: 'Topaz & Numby',
    current_app_rate: 0.27,
    prev_app_rate: 0.48,
    current_avg_score: 23652,
    prev_avg_score: 23777,
    app_eidolons: 0.2,
    app_free: 0.01,
    round_eidolons: 26897,
    round_free: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'trailblazer-destruction',
    name: 'Trailblazer - Destruction',
    current_app_rate: 0,
    prev_app_rate: 0,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-harmony',
    name: 'Trailblazer - Harmony',
    current_app_rate: 5.75,
    prev_app_rate: 10.52,
    current_avg_score: 26921,
    prev_avg_score: 30638,
    app_eidolons: 4.58,
    app_free: 0.46,
    round_eidolons: 33992,
    round_free: 25326,
    rarity: '4*'
  },
  {
    char: 'trailblazer-preservation',
    name: 'Trailblazer - Preservation',
    current_app_rate: 0.01,
    prev_app_rate: 0.04,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-remembrance',
    name: 'Trailblazer - Remembrance',
    current_app_rate: 65.75,
    prev_app_rate: 47.32,
    current_avg_score: 35296,
    prev_avg_score: 36839,
    app_eidolons: 31.33,
    app_free: 6.49,
    round_eidolons: 39344,
    round_free: 34797,
    rarity: '4*'
  },
  {
    char: 'tribbie',
    name: 'Tribbie',
    current_app_rate: 61.99,
    prev_app_rate: 63.64,
    current_avg_score: 38880,
    prev_avg_score: 39582,
    app_eidolons: 30.51,
    app_free: 7.69,
    round_eidolons: 40000,
    round_free: 39029,
    rarity: 'Limited 5*'
  },
  {
    char: 'welt',
    name: 'Welt',
    current_app_rate: 0.15,
    prev_app_rate: 0.06,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.1,
    app_free: 0.02,
    round_eidolons: 25210,
    round_free: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'xueyi',
    name: 'Xueyi',
    current_app_rate: 0.09,
    prev_app_rate: 0.25,
    current_avg_score: 0,
    prev_avg_score: 29748,
    app_eidolons: 0.04,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'yanqing',
    name: 'Yanqing',
    current_app_rate: 0,
    prev_app_rate: 0,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'yukong',
    name: 'Yukong',
    current_app_rate: 0.01,
    prev_app_rate: 0,
    current_avg_score: 0,
    prev_avg_score: 0,
    app_eidolons: 0.01,
    app_free: 0,
    round_eidolons: 0,
    round_free: 0,
    rarity: '4*'
  },
  {
    char: 'yunli',
    name: 'Yunli',
    current_app_rate: 3.36,
    prev_app_rate: 3.9,
    current_avg_score: 24955,
    prev_avg_score: 31121,
    app_eidolons: 1.85,
    app_free: 0.31,
    round_eidolons: 30919,
    round_free: 24056,
    rarity: 'Limited 5*'
  }
];
